import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import MailNewsSubscriptionForm from './components/MailNewsSubscriptionForm';
import { useMailNewsSubscriptionSettings } from './hooks/useMailNewsSubscriptionSettings';
import { useMailSubscriptionLinkVerify } from './hooks/useMailSubscriptionLinkVerify';
import { useStore } from '../../core/utils/hook';
import { SYSTEM_PATH } from '../../core/configs/constants';

const MailSubscriptionScreen = observer(() => {
    const navigate = useNavigate();
    const { linkTokenError, showMailSettingsForm } = useMailSubscriptionLinkVerify();

    const {
        modalStore: { openAlert }
    } = useStore();

    const { settings, handleToggle, handleSave, isSaving } = useMailNewsSubscriptionSettings({
        enabled: showMailSettingsForm,
        afterSaveSuccess: () => {
            openAlert(
                'メールニュースの受信設定を更新しました。',
                () => navigate(SYSTEM_PATH.HOME),
                'small',
                'トップページへ'
            );
        }
    });

    return (
        <div
            id="main"
            className="wrapper main-student-list main-view-student-detail main-view-detail-information main-detail-count-info"
        >
            <section className="top-student-list">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="detail-count-info-right mail-subscription-page">
                                <div className="mail-subscription-page__inner">
                                    <div className="mail-subscription-page__title">
                                        <h2 className="mail-subscription-page__title-text">メールニュース受信設定</h2>
                                    </div>
                                    {linkTokenError && (
                                        <div className="mail-subscription-page__token-error" role="alert">
                                            {linkTokenError}
                                        </div>
                                    )}
                                    {showMailSettingsForm && (
                                        <MailNewsSubscriptionForm
                                            settings={settings}
                                            onToggle={handleToggle}
                                            onSave={handleSave}
                                            isSaving={isSaving}
                                            tabModifierClass="mail-settings-tab--standalone"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
});

export default MailSubscriptionScreen;
